import { DbHelper } from "@base/util/DbHelper";
import { IdGen } from "@base/util/IdGen";
import { IProjectPreviewNew, IProjectPreviewOld } from "@biz/userProjects/new/IVariant";

export class ProjectPreview {
  static isOld(projectPreview: IProjectPreviewOld | IProjectPreviewNew): projectPreview is IProjectPreviewOld {
    return typeof projectPreview.image === "string" || typeof projectPreview.thumb === "string";
  }

  static asNew(projectPreview: IProjectPreviewOld | IProjectPreviewNew): IProjectPreviewNew;
  static asNew(projectPreview: IProjectPreviewOld | IProjectPreviewNew | undefined): IProjectPreviewNew | undefined;
  static asNew(projectPreview: IProjectPreviewOld | IProjectPreviewNew | undefined): IProjectPreviewNew | undefined {
    if (!projectPreview)
      return undefined;
    if (ProjectPreview.isOld(projectPreview)) {
      return {
        image: { id: projectPreview.image, token: "" },
        thumb: { id: projectPreview.thumb, token: "" },
      }
    } else {
      return projectPreview;
    }
  }

  static create(): IProjectPreviewNew {
    return {
      thumb: { id: DbHelper.createId(), token: IdGen.unsecure.get() },
      image: { id: DbHelper.createId(), token: IdGen.unsecure.get() },
    };
  }

  static ensureTokens(pp: IProjectPreviewNew): IProjectPreviewNew {
    if (!pp.image.token)
      pp = { ...pp, image: { ...pp.image, token: IdGen.unsecure.get() } }
    if (!pp.thumb.token)
      pp = { ...pp, thumb: { ...pp.thumb, token: IdGen.unsecure.get() } }
    return pp;
  }

  static update(pp: IProjectPreviewOld | IProjectPreviewNew | undefined): IProjectPreviewNew {
    if (pp) return ProjectPreview.asNew(pp);
    return ProjectPreview.create();
  }
}